import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { StorageService } from '../services/storage.service';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const storageService: StorageService = inject(StorageService);
  const authService: AuthService = inject(AuthService);
  const token = storageService.getToken();
  var request = req;
  var agent = {
    platform: 'web',
  };

  const platform = storageService.getMobile();

  if (platform !== null) {
    agent.platform = platform;
  }

  request = request.clone({
    setHeaders: {
      'X-BEDICI-AGENT': JSON.stringify(agent),
    },
  });

  if (token) {
    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        authService.logout(storageService.getGarIdo() ? 'forced' : 'manual');
      }

      return throwError(error);
    }),
  );
};
